
























    import {Component, Vue, Prop} from 'vue-property-decorator';

    import CloseBtn from "@service/components/common/close-button/CloseButton.vue";
    import { VideoController } from '@service/components/player-panel/types/VideoController';
    import { Meeting } from '@api/models/meetings/Meeting';
    import { EventInterface } from '@share/program/types/EventInterface';
    import { DateTime, Interval } from 'luxon';
	import { OnlineProvider } from "@api/enums/Session/OnlineProviderEnum";

    @Component({
        components: { CloseBtn }
    })
    export default class PlayerPanel extends Vue {

        @Prop({ required: true }) object: Meeting | EventInterface;
        @Prop({ required: true }) title: string;
        @Prop({ required: false }) controller?: VideoController;

        timer?: NodeJS.Timeout;
        timerType: "left" | "passed" = "passed";
        timerStringLeft = "";
        timerStringPassed = "";

        /**
         * width for passed time
         */
        progressWidth = "0";

        activated() {
            //условно
            if(this.object) {
                this.startWatching();
            }
        }

        startWatching() {

            const begin = this.object.beginAt;
            const end = this.object.endAt;

            if(begin && end) {
                this.timer = setInterval(() => this.watchHandler(begin, end), 1000);
            }
        }

        watchHandler(begin: DateTime, end: DateTime) {

            const now = DateTime.local();

            if((now > end) && !(this.object as EventInterface)?.isManualControlled && !((this.object as EventInterface)?.onlineProvider === OnlineProvider.pastSessionRecord)) {
                this.$emit('close');
                return;
            }

            if(now < begin) {
                this.timerStringLeft = "00:00";
                this.timerStringPassed = "00:00";
                this.progressWidth = "0";
                return;
            }

            const fromBeginToEnd = Interval.fromDateTimes(begin, end);
            const fromBeginToNow = Interval.fromDateTimes(begin, now);
            const fromNowToEnd = Interval.fromDateTimes(now, end);

            const objectDuration = fromBeginToEnd.toDuration().toObject()?.milliseconds || 1;
            const passedDuration = fromBeginToNow.toDuration().toObject()?.milliseconds || 0;

            this.timerStringLeft = `-${fromNowToEnd.toDuration(['minutes', 'seconds']).toFormat("hh:mm:ss")}`;
            this.timerStringPassed = fromBeginToNow.toDuration(['minutes', 'seconds']).toFormat("hh:mm:ss");
            this.progressWidth = ((passedDuration / objectDuration) * 100).toFixed(2);
        }

        toggleTimerType() {
            this.timerType = this.timerType === "left" ? "passed" : "left";
        }

        clearTimer() {
            if(this.timer) {
                clearInterval(this.timer);
            }
        }

        deactivated() {
            this.clearTimer();
        }

        destroyed() {
            this.clearTimer()
        }

        get ended() {
            const now = DateTime.local();
            const end = this.object.endAt;
            return end ? now > end : true
        }

        get paused() {
            return this.$store.state.miniPlayer.paused
        }

        set paused(paused: boolean) {
            this.$store.dispatch("miniPlayer/setPaused", paused)
        }
    }
